import React, { useEffect, useMemo } from "react";

import PageTitle from "../../../../../../components/PageTitle";

import { useSurveyStatus } from "../../store/store";
import { useEditParticipants, useSetters, useSurveyAccess } from "./store/store";

import { useParticipantData } from "./hooks/useParticipantData";
import { useViewSelector } from "./hooks/useViewSelector";

import css from "../../../../../../pageTemplates/BasePageTemplate/BasePageTemplate.module.scss";
import { SURVEY_PARTICIPANTS_CONFIG } from "./constants";
import { AllEmployees, Participants, SelectParticipants } from "./views";

export const SurveyParticipants = ({ surveyId }: { surveyId: string }) => {
	const { isParticipantSelectionEnabled } = useParticipantData(surveyId);
	const surveyAccess = useSurveyAccess();
	const surveyStatus = useSurveyStatus();
	const editParticipants = useEditParticipants();
	const setters = useSetters();

	const viewType = useViewSelector(surveyAccess as string, editParticipants, surveyStatus || "");

	useEffect(() => {
		if (isParticipantSelectionEnabled) {
			setters.setSurveyAccess(SURVEY_PARTICIPANTS_CONFIG.SURVEY_ACCESS.SELECTED_EMPLOYEES);
		}
	}, [isParticipantSelectionEnabled, setters]);

	const ViewComponent = useMemo(() => {
		switch (viewType) {
			case SURVEY_PARTICIPANTS_CONFIG.VIEW_TYPES.ALL_EMPLOYEES:
				return <AllEmployees surveyId={surveyId} />;
			case SURVEY_PARTICIPANTS_CONFIG.VIEW_TYPES.SELECT_PARTICIPANTS:
				return <SelectParticipants surveyId={surveyId} />;
			case SURVEY_PARTICIPANTS_CONFIG.VIEW_TYPES.PARTICIPANTS:
				return <Participants surveyId={surveyId} />;
			default:
				return <AllEmployees surveyId={surveyId} />;
		}
	}, [viewType, surveyId]);

	return (
		<div className={css.pageContainer}>
			<PageTitle title="Survey Participants" />
			<div className={`${css.background} ${css.grey}`}></div>
			<div className={css.pageContents}>
				<div className="m-auto mt-[24px] rounded bg-white px-10 py-4">{ViewComponent}</div>
			</div>
		</div>
	);
};
